import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.nivelPuesto.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.nivelPuesto.fields.nombre'),
  },
  {
    name: 'nivel',
    label: i18n('entities.nivelPuesto.fields.nivel'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.nivelPuesto.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.nivelPuesto.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
